import { AxiosError } from "axios";
import { useSetAtom } from "jotai";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Intent, IntentSentence, IntentSentenceCreate } from "@/model";
import sentenceRepository from "@/repository/sentenceRepository";
import { intentQueryKeys } from "@/query/intent";
import { intentTableRefetchAtom } from "@/atom/intentTable";


export const useCreateIntentSentence = (agentId: number, skillId?: number, intentId?: string) => {
    const queryClient = useQueryClient();
    const setIntentTableRefetch = useSetAtom(intentTableRefetchAtom);

    return useMutation<IntentSentence, AxiosError, IntentSentenceCreate>({
        mutationKey: ["intent-sentence", "agent", agentId, "skill", skillId, "intent", intentId, "create"],
        mutationFn: async (body: IntentSentenceCreate) => {
            try {
                const { data } = await sentenceRepository.create(agentId, skillId!, intentId!, body);
                return data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async (newIntentSentence) => {
            const intents = await queryClient.getQueryData(intentQueryKeys.intents(agentId, skillId)) as Intent[];

            intents.forEach(intent => {
                if (intent.id === intentId) {
                    intent.sentences = [newIntentSentence, ...intent.sentences];
                }
            });
            setIntentTableRefetch(true);
        }
    });
};
